// src/components/auth/VerifyEmail.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import './auth.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const VerifyEmail = ({ setIsAuthenticated, setUser }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  // status: 'verifying' | 'success' | 'error'
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('Verifying your email...');

  const verify = useCallback(async () => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token found. Please use the link from your email.');
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/auth/verify-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });

      const data = await response.json();

      if (response.ok && data.token) {
        // Now that the email is verified, store the real (full-access) token.
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('userInfo', JSON.stringify(data.user));

        if (setIsAuthenticated) setIsAuthenticated(true);
        if (setUser) setUser(data.user);

        setStatus('success');
        setMessage('Your email is verified. Redirecting to your dashboard...');

        setTimeout(() => {
          navigate(data.user?.role === 'admin' ? '/admin/dashboard' : '/dashboard');
        }, 1500);
      } else {
        setStatus('error');
        setMessage(data.error || 'This verification link is invalid or has expired.');
      }
    } catch (err) {
      console.error('Verification error:', err);
      setStatus('error');
      setMessage('Could not reach the server. Please try again.');
    }
  }, [token, navigate, setIsAuthenticated, setUser]);

  useEffect(() => {
    verify();
  }, [verify]);

  return (
    <div className="auth">
      <div className="auth__container" style={{ textAlign: 'center', maxWidth: 480 }}>
        <div className="auth__form-section" style={{ width: '100%' }}>
          {status === 'verifying' && (
            <>
              <span className="spinner" style={{ width: 40, height: 40, margin: '0 auto 20px' }}></span>
              <h2>Verifying your email</h2>
              <p>{message}</p>
            </>
          )}

          {status === 'success' && (
            <>
              <i className="bx bx-check-circle" style={{ fontSize: 56, color: '#43e97b' }}></i>
              <h2>Email verified!</h2>
              <p>{message}</p>
            </>
          )}

          {status === 'error' && (
            <>
              <i className="bx bx-error-circle" style={{ fontSize: 56, color: '#e74c3c' }}></i>
              <h2>Verification failed</h2>
              <p>{message}</p>
              <div style={{ marginTop: 20 }}>
                <Link to="/login" className="button button--flex">Back to Login</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;